module.exports = __webpack_public_path__ + "static/media/equalicare-img17.e6fb9eab.png";